// Zentrales Branding für artnexx.ru
// Damit können wir Domain/Name/Farben konsistent in SEO + UI verwenden.

export const BRAND = {
  domain: 'artistix.ru',
  // IMPORTANT: canonical base URL for SEO.
  // Prefer explicit env (build-time), otherwise use current origin (runtime) to avoid wrong canonicals.
  baseUrl:
    (process.env.REACT_APP_BASE_URL || '').trim() ||
    (typeof window !== 'undefined' && window.location && window.location.origin
      ? String(window.location.origin).replace(/\/$/, '')
      : 'https://artistix.ru'),
  // sichtbarer Markenname (UI)
  name: 'artistiX.ru',
  // kurzer Name (PWA, Meta, etc.)
  shortName: 'artistiX',

  // Textvorschläge (RU wie im Screenshot)
  titleRu: 'artistiX.ru',
  claimRu: 'Каталог творческих лиц и коллективов',
  logoRu: 'Каталог творческих лиц и коллективов',
  logo_1: 'artisti',
  logo_2: 'X',
  logo_3: '.ru',

  // Kontakt (Footer)
  contactEmail: 'info@artistix.ru',

  // Primärfarbe (Screenshot: Rot)
  themeColor: '#d11f2a'
};
